import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=stylized%20webtoon%20manga%20collage%20hero%20banner%20illustration%2C%20cheerful%20diverse%20comic%20characters%20floating%20in%20dreamy%20fluffy%20clouds%2C%20warm%20orange%20caramel%20cream%20gradient%20sky%2C%20floating%20books%20and%20heart%20shapes%2C%20clean%20flat%20vector%20art%2C%20cozy%20inviting%20atmosphere%2C%20wide%20banner%20composition%2C%20no%20text&width=1600&height=900&seq=hero-2026-pudding&orientation=landscape';

const featured = comics[0];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[520px] w-full md:h-[600px]">
        <img
          src={HERO_IMAGE}
          alt="布丁漫画网海量漫画在线免费阅读"
          title="布丁漫画网在线免费阅读漫画"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/40 to-foreground-950/75"></div>

        <div className="absolute inset-0 flex w-full flex-col items-center justify-center px-4 text-center">
          <span className="animate-fade-up inline-flex items-center gap-1.5 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur md:text-sm">
            <i className="ri-flashlight-fill text-sm text-primary-300"></i>
            今日已更新 56 话 · 全站免费在线阅读
          </span>

          <h1 className="animate-fade-up mt-5 font-heading text-4xl leading-tight text-background-50 md:text-6xl" style={{ animationDelay: '0.1s' }}>
            布丁漫画网
          </h1>
          <p className="animate-fade-up mt-4 max-w-2xl text-sm leading-7 text-background-100 md:text-base" style={{ animationDelay: '0.2s' }}>
            在线免费阅读《寄宿日记》漫画，畅读全集中文版本。
            <br className="hidden md:block" />
            无需付费即可体验流畅的在线浏览和丰富故事。
          </p>

          <div className="animate-fade-up mt-7 flex flex-col items-center gap-3 sm:flex-row" style={{ animationDelay: '0.3s' }}>
            <Link
              to="/read/jsrj/1"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              开始阅读《寄宿日记》
            </Link>
            <Link
              to="/category"
              className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              浏览全部漫画
              <i className="ri-arrow-right-s-line"></i>
            </Link>
          </div>

          <div className="animate-fade-up mt-9 flex flex-wrap items-center justify-center gap-x-8 gap-y-3" style={{ animationDelay: '0.4s' }}>
            {[
              { value: '1,200+', label: '收录作品' },
              { value: '56', label: '今日更新话' },
              { value: '20万+', label: '在线读者' },
              { value: '9.4分', label: '口碑评分' },
            ].map((item) => (
              <div key={item.label} className="flex items-baseline gap-1.5">
                <span className="font-heading text-xl text-primary-300 md:text-2xl">{item.value}</span>
                <span className="text-xs text-background-100 md:text-sm">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}